<template>
  <div class="header-select task-card-select">
    <div class="select-wrapper">
      <div>
        <slot name="wrapper">

        </slot>
      </div>
      <nav class="header-select-options">
        <template v-if="taskData.created">
          <a @click="archive()" v-if="!taskData.archived"><i class="bi bi-folder"></i>{{ $t("archive") }}</a>
          <a @click="unarchive()" v-else><i class="bi bi-folder2-open"></i>{{ $t("unarchive") }}</a>
        </template>
        <template v-if="taskData.created">
          <a @click="edit()" v-if="!taskData.editing"><i class="bi bi-pencil-square"></i>{{ $t("edit") }}</a>
          <a @click="show()" v-else><i class="bi bi-eye"></i>{{ $t("show") }}</a>
        </template>
        <a @click="removeTask()"><i class="bi bi-trash text-danger"></i><span class="text-danger">{{ $t("remove") }}</span></a>
      </nav>
    </div>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';

  export default {
    methods: {
      ...mapActions('taskStoreModule', ['deleteTask', 'archiveTask', 'unarchiveTask', 'editTask', 'showTask']),
      removeTask(){
        this.deleteTask({task_id: this.taskData.id, renderId: this.taskData.renderId })
      },
      archive(){
        this.archiveTask({task_id: this.taskData.id})
      },
      unarchive(){
        this.unarchiveTask({task_id: this.taskData.id})
      },
      edit(){
        this.editTask({task_id: this.taskData.id})
      },
      show(){
        this.showTask({task_id: this.taskData.id})
      }
    },
    props: {
      taskData: {
        type: Object,
        default: () => ({})
      }
    },
  }
</script>
